 function scrollDown(){
	var valScroll = $(window).scrollTop();
	if(valScroll>=40){
		$('body').addClass('scroll');
	}else{
		$('body').removeClass('scroll');
	}
}

function changeHeader(){
	if ($(window).width() < 580) {
		$('.h-desktop').hide();
		$('.h-mobile').show(function(){
			$('.sym-slides-mobile').slick();
		});
	} else {
		$('.h-mobile').hide();
		$('.h-desktop').show(function(){
			$('.sym-slides-desktop').slick();
		});
	}
}


 $(window).resize(function(){
 	changeHeader();
 });


$(window).load(function(){
	equalize();
		
	$('.sym-slides:not(.slick-initialized)').slick();
	
	setTimeout(function(){
		$('body').addClass('loaded');
		setTimeout(function(){
			$('#header').addClass('loaded')
		},700);
	}, 800);

	
	setTimeout(function(){
		var $grid = $('#accommodations');
		$grid.isotope({
			filter: '*',
			transitionDuration: 0
		});
	},300);

	changeHeader();
});
var a = 0;
$(window).bind('load scroll', function(){
	var valScroll = $(window).scrollTop();
	var winHeight = $(window).innerHeight();
	$('.scroll-icon').each(function () {
		var thisTop = $(this).offset().top;
		if (valScroll >= thisTop - (winHeight * 0.7)) {
			$(this).addClass('visible')
		}
	});

	if( $('.counter-value').length > 0 ){
		var oTop = $('#numbers').offset().top - window.innerHeight;
		  if (a == 0 && $(window).scrollTop() > oTop) {
		    $('.counter-value').each(function() {
		      var $this = $(this),
		        countTo = $this.attr('data-count');
		      $({
		        countNum: $this.text()
		      }).animate({
		          countNum: countTo
		        },
		
		        {
		
		          duration: 2000,
		          easing: 'swing',
		          step: function() {
		            $this.text(Math.floor(this.countNum));
		          },
		          complete: function() {
		            $this.text(this.countNum);
		            //alert('finished');
		          }
		
		        });
		    });
		    a = 1;
		  }
	 }
})

$(window).bind('load resize', function(){
	var winWidth = $(window).innerWidth();
	if(winWidth <= 1024){
		$('#primary-nav li a.active').siblings('.submenu').show();
		$('#primary-nav li a').off('click').on('click', function(event){
			var $this = $(this);
			if($this.siblings('.submenu').size()>0){
				event.preventDefault();
				$this.siblings('.submenu').slideToggle();
			}
		})
	}
})

$(document).ready(function () {

	// RESTAURANT MENUS FILTER MOBILE
	document.querySelectorAll('.restMenus_filterMobile select').forEach((filter, i) => {
		filter.addEventListener('change', _ => {
			document.querySelectorAll('.restMenus_item').forEach(room => {
				room.classList.remove('active');
				if ( filter.value === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) {
			let eventChange = document.createEvent('HTMLEvents');
			eventChange.initEvent('change', true, false);
			filter.dispatchEvent(eventChange);
		}
	});

	// RESTAURANT MENUS FILTER
	document.querySelectorAll('.restMenus_filter li').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.restMenus_filter li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.restMenus_item').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) btn.click();
	});

	$("#footer").html(function(buscayreemplaza, reemplaza) {
    return reemplaza.replace('<nav id="secondary-nav" class="secondary-navigation" role="navigation">', '<nav id="secondary-nav-footer" class="secondary-navigation" role="navigation">');
	});
	$("#footer").html(function(buscayreemplaza, reemplaza) {
    return reemplaza.replace('<ul id="secondary-navigation" class="secondary-navigation__list">', '<ul id="secondary-navigation-footer" class="secondary-navigation__list">');
	});

	$('.js-open-textcode').click(function(e){
		e.preventDefault(); 
		let textcode= $(this).attr("href")
		$(textcode).stop().slideToggle();
	});

	/* Inset custom slick arrows */
	$('.custom-slick-prev').on('click', function(e){
		e.preventDefault();
		$(this).closest('.sym-slides').slick('slickPrev');
	});
	$('.custom-slick-next').on('click', function(e){
		e.preventDefault();
		$(this).closest('.sym-slides').slick('slickNext');
	});
	
	$('.btn-amenities').click(function(){
		if($(this).closest('.room').find('.content-amenities').is(':hidden')){
			$(this).addClass('open').text('Close amenities');
			$(this).closest('.room').find('.content-amenities').slideDown();
		}else{
			$(this).removeClass('open').text('View amenities');
			$(this).closest('.room').find('.content-amenities').slideUp();
		}
		setTimeout(function(){
			var $grid = $('#accommodations');
			$grid.isotope();
		},400);

	})
	$('.close-booking').click(function(event){
		event.preventDefault();
		$('.content-booking').removeClass('open');		
	});

	// $('.booking-btn').click(function(event){
	// 	event.preventDefault();
	// 	$('.content-booking').addClass('open');		
	// });
	$('.animated-svg').each(function () {
		var svg = $(this).find('svg');
	  svg.svgTracer({duration:'2.5s'});
	  $('#player').click(function(){
	    if(svg.data('svgTracer').isVisible){
	      svg.svgTracer('reverse');
	    } else {
	      svg.svgTracer('play');
	    }
	    return false;
	  });
	});
	var animated = 0;
	$(window).scroll(function(){
		var valScroll = $(window).scrollTop();
		var winHeight = $(window).innerHeight();
		$('.animated-svg').each(function () {
			var thisTop = $(this).offset().top;
			if (valScroll >= thisTop - (winHeight * 0.8)) {
				if(animated == 0){
					console.log('hola')
					$('#player').trigger('click');
					animated = 1
				}
				
			}
		})
	});

	/* Landing scroll btn */
	$('.scrollTo').on('click', function(){
		console.log('scrolleo');
		var disBtn = $(this);
		var target = disBtn.attr('href');
		var tragetEl = $(target);
		if( tragetEl.length > 0 ){
			var targetPos = tragetEl.offset().top - 90;
			$("html, body").animate({ scrollTop: targetPos }, 1000);
		}
		
	});

	$('body').addClass('inited')

    //Acts when scroll down page.
    $(window).scroll(function (event) {
    	scrollDown();
		});

	//Home page scroll down arrow. If present.
	$('.scroll-down').click(function(event) {
	    $('body, html').animate({
	        scrollTop: $(window).height()-$('header').outerHeight()*2},
	        1200, 'easeOutExpo');
	});
	
	//Remove empty <p> tags created by tinymce
	$('p').each(function() {
	    var $this = $(this);
	    if($this.html().replace(/\s|&nbsp;/g, '').length == 0)
	        $this.remove();
	});

	//Event Tracking
	//this class should be add to any link to the booking engine
    $('.book-now').on('click', function () {
        if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
    });
	//this class should be add to the header widget submit button
    $('.bookNow').on('click', function () {
        if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
    });

    //Event Tracking Forms
	$('.weddingsSubmit').on('click', function () {
	    ga('send', 'event', 'Forms', 'click', 'Weddings RFP');
	});

	$('.meetingsSubmit').on('click', function () {
	    ga('send', 'event', 'Forms', 'click', 'Meetings RFP');
	});


	//Check in and check out datepicker for booking engine yyyy-mm-dd
	$( "#CheckIn" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		minDate: 0,
		dateFormat: 'yy-mm-dd',
		onSelect: function( selectedDate ) {
			getDate = $(this).datepicker('getDate');
        	newDate = new Date(getDate.getTime());
        	newDate.setDate(newDate.getDate() + 3);
			$( "#CheckOut" ).datepicker( "setDate", newDate );
			$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
		}
	});
	$( "#CheckOut" ).datepicker({
		//showOn: "both",
		//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
		//buttonImageOnly: true,
		changeMonth: true,
		numberOfMonths: 2,
		dateFormat: 'yy-mm-dd',
		onSelect: function( selectedDate ) {
			$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
		}
	});
	
	// Map: Return to previous page button. Change body id to match map template's name.
	$('body#map #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

	$('#email-signup a#emailSignupCustom').click(function () {
      var firstname = $('input[name=first_name_signup]');
      var lastname = $('input[name=last_name_signup]');
      var email_address = $('#email-signup input[name=email_address_signup]');
      var lang = $('#email-signup input[name=lang]');
      var data = 'firstname=' + firstname.val() + '&lastname=' + lastname.val() + '&email_address=' + email_address.val() + '&list_id=' + list_id + '&language=' + lang.val();

      $url = $(email_address).attr('data-url');

      //start the ajax
      $.ajax({
          url: site_url + "ajax/email-signup.php",
          type: "GET",
          data: data,
          cache: false,
          success: function (html) {

              var customMessage = ( $("#customMessage").length ) ? $("#customMessage").val() : '';
              customMessage = (customMessage == '') ? "Thank you for your interest." : customMessage;

              if (html == 1) {
                  //Success
                  $('#email-signup #email-error').addClass('success');
                  if($('body').hasClass('lang-es')) {
                    $('#email-signup #email-error').html('<p>'+customMessage+'</p>');	
                  } else {    
                    $('#email-signup #email-error').html('<p>'+customMessage+'</p>');                    
                  }
                  $('#email-signup #email-error').fadeIn('slow');
                  $('#email-signup input').fadeOut('slow');
                  $('#email-signup label').fadeOut('slow');
                  $('#email-signup a#emailSignup').fadeOut('slow'); 
                  setTimeout(function() {
                    $('#email-signup #email-error').fadeOut('slow');
                    $('#email-signup input').fadeIn('slow');
                    $('#email-signup input').val('');
                    $('#email-signup label').fadeIn('slow');
                    $('#email-signup a#emailSignup').fadeIn('slow'); 
                  }, 5000);
                  if(typeof (ga) == "function") {
                  	ga('send', 'event', 'form', 'click', 'specials');
                  }
                  if(typeof (dataLayer.push) == "function") {
                  	//var dataLayer = [];
				dataLayer.push({ 'event': 'email_signup' });
				console.log(data);
              	}
              } else { 
                //Error
                  $('#email-signup #email-error').html(html);
                  $('#email-signup #email-error').fadeIn('slow');
              } 
          }
      });
      return false;
  });

  $('.nav-icon').click(function(){
  	if($(this).hasClass('open')){
  		$(this).removeClass('open');
  		$('.content-nav').removeClass('open2');
  		setTimeout(function(){
  			$('.content-nav').removeClass('open');
  		},400);
  	}else{
  		$(this).addClass('open');
  		$('.content-nav').addClass('open');
  		setTimeout(function(){
  			$('.content-nav').addClass('open2');
  		},400);
		}
	});
	$('.close-menu').click(function(){
		$(this).removeClass('open');
		$(this).removeClass('open2');
	});
	

  var filtersSelect = document.getElementById('careers-filter__select');
  if(filtersSelect){
	  filtersSelect.addEventListener('change', function(){
	  	var thisval = filtersSelect.value;
	  	console.log(thisval);
	  	var allcats = document.querySelectorAll('.careers-category');
	  	var thisCat = document.querySelectorAll('.category-'+thisval+'');
	  	if( allcats )
		  	for(var i = 0; i < allcats.length; i++ ){
		  		allcats[i].style.display = 'none';
		  	}
	  	for(var i = 0; i < thisCat.length; i++ ){
	  		thisCat[i].style.display = '';
	  	}
	  })
	}

	/* Weddings landing */
	$('#gallery__overtext').insertAfter( '.wedding-gallery__item:nth-child(2)');
	
});

var changeEvents = document.querySelector("[data-category='Events']");
if ( changeEvents ) {
	changeEvents.innerHTML = "Hotel Events";
}
